import {
  getGoodsDetailPageUrl,
  ProductCard,
  ProductCardProps,
} from '@bucketplace/common';
import React from 'react';

import { APP_PROFILE } from '@/common';
import { SuperLink } from '@/components/Layout';

export function ProductCardSectionItem({
  product,
  className,
  logData,
}: ProductCardProps): React.ReactElement {
  return (
    <ProductCard
      product={product}
      className={className}
      linkComponent={SuperLink}
      href={getGoodsDetailPageUrl({
        goodsId: String(product.id),
        env: APP_PROFILE === 'local' ? 'dev' : APP_PROFILE,
      })}
      logData={logData}
    />
  );
}
